if (!customElements.get('video-facade')) {
  class VideoFacade extends HTMLElement {
    connectedCallback() {
      this.playButton = this.querySelector('.js-play-video');
      if (!this.playButton) return;

      this.playButton.addEventListener('click', this.handlePlayClick.bind(this), { once: true });
    }

    /**
     * Replaces the placeholder with the provider iframe. Nothing is requested
     * from the third party before this point.
     */
    handlePlayClick() {
      const { embedUrl, provider } = this.dataset;
      if (!embedUrl) return;

      const iframe = document.createElement('iframe');
      iframe.setAttribute('src', embedUrl);
      iframe.setAttribute('title', provider || 'Video');
      iframe.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; web-share');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('loading', 'lazy');

      this.replaceChildren(iframe);
    }
  }

  customElements.define('video-facade', VideoFacade);
}
